import { Capacitor } from '@capacitor/core'
import type { Position } from '@capacitor/geolocation'
import { Geolocation as NativeGeolocation } from '@capacitor/geolocation'

interface Geolocation {
  checkPermissions: () => Promise<PermissionState>
  getCurrentPosition: (options?: PositionOptions) => Promise<Position>
}

class WebLocation implements Geolocation {
  geoLocation = navigator

  async checkPermissions() {
    const permissions = await this.geoLocation.permissions.query({
      name: 'geolocation',
    })
    return permissions.state
  }
  async getCurrentPosition(options?: PositionOptions) {
    return (await new Promise<GeolocationPosition>((resolve, reject) => {
      this.geoLocation.geolocation.getCurrentPosition(
        resolve,
        (error) => {
          const message = error.message
            ? `Could not determine location: ${error.message}`
            : `Could not determine location (code ${error.code})`
          reject(new Error(message))
        },
        options,
      )
    })) as Position
  }
}

class NativeLocation implements Geolocation {
  geoLocation = NativeGeolocation

  async checkPermissions() {
    const { location } = await this.geoLocation.checkPermissions()
    return location as PermissionState
  }
  async getCurrentPosition(options?: PositionOptions) {
    return this.geoLocation.getCurrentPosition(options)
  }
}

export const getAppLocation = (): Geolocation | null => {
  if (Capacitor.isNativePlatform()) return new NativeLocation()
  if (typeof navigator !== 'undefined' && navigator.permissions)
    return new WebLocation()
  return null
}
